export default __webpack_public_path__ + "static/media/148.53cef4cf.gif";